/*
 * File: \lib\api-wrapper.js
 * File Created: 2022-04-05 15:31:25
 * Author: Li Haifeng
 * -----
 * Last Modified: 2023-02-21 10:28:19
 * Modified By: lihf14
 */
import { tools } from "@midea/mx-cli-module-core";

const { isMission } = tools;

function nativeAPIWrapper(native) {
  const api = native && native.mxNativeApis;
  if (!api) throw new Error('nativeAPIWrapper api is null')

  let config = native.config.getConf();

  Object.keys(config.mock).forEach((key) => {
    if (key === "getUser") {
      getUserWrapper(api, config.mock[key]);
    } else {
      generalWrapper(api, key, config.mock);
    }
  });
  
  native.wrapGlobalApis();

  return native;
}

function generalWrapper(apis, name, mock) {
  if(!name) {
    return;
  }
  const api = apis[name];
  if (typeof api !== "function") return;

  apis[name] = function (...args) {
    return new Promise((resolve, reject) => {
      if (
        // 开发时 使用本地用户数据，目前判断为非美信环境（发布包后，项目识别不了process.env.NODE_ENV变量）
        !isMission()
      ) {
        resolve(mock[name]);
        return;
      }
      api.apply(apis, args).then(resolve).catch(reject);
    });
  }
}

function getUserWrapper(api, mockUser) {
  const getUser = api.getUser
  if (typeof getUser !== 'function') return

  api.getUser = function (...args) {
    return new Promise((resolve, reject) => {
      if (
        // 开发时 使用本地用户数据，目前判断为非美信环境（发布包后，项目识别不了process.env.NODE_ENV变量）
        !isMission()
      ) {
        resolve(mockUser);
        return;
      }

      let etag = new EndTag()

      const _resolve = (...agrs) => {
        if (etag) {
          etag.end()
          etag = null
          resolve(...agrs)
          return;
        }
      }

      const _reject = (...agrs) => {
        if (etag) {
          etag.end()
          etag = null
          reject(...agrs)
          return;
        }
      }

      getUser.apply(api, args).then(_resolve).catch(_reject);
      // 解决 getUser 在安卓环境下同时触发多次未响应的问题
      [200, 400, 600, 800, 1000].forEach(time => {
        etag.timers.push(setTimeout(() => {
          if (etag && !etag.isEnd) {
            console.log('getUser timeout')
            getUser.apply(api, args).then(_resolve).catch(_reject)
          }
        }, time))
      })
    });
  }
}

class EndTag {
  constructor() {
    this.isEnd = false
  }

  get timers() {
    if (!this._timers) this._timers = []
    return this._timers
  }

  end() {
    this.isEnd = true
    this.timers.forEach(num => clearTimeout(num))
  }
}

export default nativeAPIWrapper
